import React from "react";

export interface ProjectsOverviewProps {
	workspaceId: string;
	session?: any;
	currentWorkspace?: any;
}

export const ProjectsOverview: React.FC<ProjectsOverviewProps> = ({
	workspaceId,
	session,
	currentWorkspace,
}) => {
	return (
		<div className="flex h-full flex-col items-center justify-center bg-background p-8 text-foreground">
			<h1 className="mb-2 font-bold text-2xl">Projects Overview</h1>
			<p className="text-muted-foreground">
				Workspace: <span className="font-mono">{workspaceId}</span>
			</p>
			<p className="mt-4 text-muted-foreground text-sm">
				Projects overview content would go here
			</p>
		</div>
	);
};